export const LAYOUT_SECTION_MARGIN = 8;
export const LAYOUT_COLUMN_PADDING = LAYOUT_SECTION_MARGIN * 1.5;
export const DEFAULT_TWO_COLUMN_LAYOUT_COLUMN_WIDTH = 50;
